<template>
  <ValidationProvider v-slot="{ errors }"
                      :vid="vid"
                      :name="name"
                      :rules="rules"
                      tag="div"
                      ref="provider"
  >
    <AGCLabel v-if="label" :required="required">
      <slot>{{ label }}</slot>
      <template v-slot:subLabel>
        <slot name="subLabel">{{ subLabel }}</slot>
      </template>
    </AGCLabel>
    <div v-if="readOnly" v-html="inputVal" class="content-editor--readonly">
      <!-- handle vee validate -->
      <input type="hidden" v-model="inputVal">
    </div>
    <editor v-else
            v-model="inputVal"
            :apiKey="apiKey"
            :init="options"
            @onBeforeSetContent="handlePasteImg"
    ></editor>
    <span v-if="errors" class="content-editor__error">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { ValidationProvider } from 'vee-validate';
import Editor from '@tinymce/tinymce-vue';
import vModelMixin from '@/mixins/v-model';
import imagePath from '@/filters/image-path';
import AGCLabel from '@/components/form/AGCLabel.vue';

export default {
  mixins: [vModelMixin],
  components: {
    ValidationProvider,
    editor: Editor,
    AGCLabel,
  },
  props: {
    vid: {
      type: String,
      default: undefined,
    },
    rules: [Object, String],
    name: String,
    label: String,
    subLabel: String,
    uploadType: String,
    readOnly: Boolean,
    required: Boolean,
    toolbar: {
      type: Array,
      default: () => [`
        undo redo |
        bold italic underline strikethrough |
        alignleft aligncenter alignright alignjustify |
        bullist numlist outdent indent |
        superscript subscript |
        image table link blockquote hr |
        charmap
      `],
    },
    pasteImg: {
      type: Boolean,
      default: false,
    },
    init: Object,
  },
  data() {
    return {
      editor: null,
      apiKey: process.env.VUE_APP_TINYMCE_KEY,
    };
  },
  computed: {
    ...mapGetters(['role']),
    options() {
      return {
        content_css: `${process.env.VUE_APP_TINYMCE_CSS_PATH}?${new Date().getTime()}`,
        language_url: process.env.VUE_APP_TINYMCE_LANGUAGE_PATH,
        language: 'zh_TW',
        height: 500,
        menubar: '',
        plugins: [
          // 'autoresize',
          'quickbars',
          'paste',
          'hr',
          'lists advlist',
          'image imagetools',
          'autolink link charmap',
          'searchreplace visualblocks fullscreen',
          'preview anchor insertdatetime',
          'importcss code help wordcount table',
        ],
        toolbar: this.toolbar,
        convert_urls: false,
        image_title: true,
        image_caption: true,
        image_dimensions: false,
        images_upload_handler: this.uploadType ? this.handleImageUpload : null,
        quickbars_image_toolbar: 'alignleft aligncenter alignright',
        quickbars_selection_toolbar: 'bold italic underline | quicklink',
        insertdatetime_formats: ['%Y年%m月%d日', '%I:%M:%S %p'],
        imagetools_toolbar: 'imageoptions',
        quickbars_insert_toolbar: false,
        nowrap: false,
        ...this.init,
      };
    },
  },
  filters: {
    imagePath,
  },
  methods: {
    handleImageUpload({ blob }, success, failure) {
      const data = new FormData();
      data.append('upload', blob());
      axios({
        method: 'POST',
        url: `/agc-${this.role}-api/upload/image`,
        params: { type: this.uploadType },
        data,
      })
        .then(({ data: { payload } }) => {
          success(this.$options.filters.imagePath(payload, 'couponContentImages', 'default', false));
        })
        .catch((e) => {
          failure(e);
        });
    },

    handlePasteImg(e) {
      if (!this.pasteImg) {
        if (e.content.includes('<img src')) {
          e.preventDefault();
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.content-editor__error {
  font-size: 80%;
  color: #dc3545;
}

.content-editor--readonly {
  word-wrap: break-word;
}

</style>
